document.addEventListener("click",e=>{const t=e.target.closest(".js-show-first-row");if(t){e.preventDefault();const s=t.querySelectorAll(".row");t.querySelectorAll(".js-show-buttons").forEach(e=>{e.classList.toggle("d-none")}),s.forEach(e=>{e.classList.toggle("d-flex")})}},!1);
//# sourceMappingURL=show-more.js.map
